import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // Class Definition
    OndigoNS.SimpleFilter = function (element) {
        this.$filter = $(element);
        this.$criterias = $('.criteria', this.$filter);
        this.$results = $('.immoTeaser', this.$filter);

        this.init();
    };

    OndigoNS.SimpleFilter.prototype = {
        init : function () {
            var _scope = this;

            this.$criterias.find('input').on('click', function () {
                _scope.$results.hide();
                $('.immoTeaser[data-group="' + $(this).data('group') + '"]', _scope.$filter).css('display', 'flex');
            });
            $.each(_scope.$criterias, function() {
                if ($('.immoTeaser[data-group="' + $(this).find('input').data('group') + '"]', _scope.$filter).length) {
                    $(this).css('display', 'inline-block');
                }
            });
        }
    };

    // plugin definition
    $.fn.simpleFilter = function () {
        return new OndigoNS.SimpleFilter(this);
    };
    $.fn.simpleFilter.Constructor = OndigoNS.SimpleFilter;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    if ($('.simpleFilter').length) {
        $('.simpleFilter').simpleFilter();
    }
});